import moment from "moment";

export default {
  salesRepVacationMessage: function (repVacation) {
    var repName = repVacation.name || repVacation.contact_email;
    var message = repName + " is currently out of office";
    if (repVacation.end_time) {
      var endDate = moment(repVacation.end_time).format("MMMM D, YYYY");
      message += " until " + endDate;
    }
    var coveringRepName =
      repVacation.covering_sales_rep.name || repVacation.covering_sales_rep.contact_email;
    message += ". " + coveringRepName + " will be managing their orders until they return.";
    return message;
  },
};
